import { computeFaqClick } from '../helpers/faq-helper';
import { relatedContent } from '../helpers/search-helpers';

document.addEventListener('turbolinks:load', function() {
  const body = $('body');
  if (body.data('controller') !== 'contact' || body.data('action') !== 'new') return;

  pageBootstrap();
});

let applyMasks = () => {
  $('#user_mobile_phone').mask('(000) 000-0000');
};

let checkSubmittableTopic = () => {
  const questionTopic = $('#question_topic_id');
  let unsubmittableIDs = questionTopic.data('unsubmittable');
  questionTopic.change(function () {
    let selectedId = parseInt(this.value);

    if ($.inArray(selectedId, unsubmittableIDs) === -1) {
      toggleFields(false, "#delayAlert", ".unsubmittableAlert");
    } else {
      toggleFields(true, ".unsubmittableAlert", "#delayAlert");
    }
  });
};

let toggleFields = (disabledStatus, selectorToShow, selectorToHide) => {
  $("#btnSubmit").attr("disabled", disabledStatus);
  $("#question_content").attr("disabled", disabledStatus);
  $(selectorToHide).hide();
  $(selectorToShow).show();
};

export let pageBootstrap = () => {
  checkSubmittableTopic();
  relatedContent('.question-ajax-form', '.question-container','related_content', '.related-content .category-container');
  computeFaqClick();
  applyMasks();
  submitContactQuestionHandler();
};

let submitContactQuestionHandler = () => {
  var contactUsForm = $("#contact-new-form");
  contactUsForm.on('ajax:success', () => {
    handleAjaxSuccess();
  });
  contactUsForm.on('ajax:complete', e => {
    handleAjaxComplete(e.detail[0].responseText);
    pageBootstrap();
  });
};

let handleAjaxSuccess = () => {
  var flashDiv = $('.flash-message').fadeIn();
  setTimeout(function() {
    flashDiv.fadeOut('slow');
  }, 5000);
};

let handleAjaxComplete = (data) => {
  var questionDiv = $('.new-message-form');
  questionDiv.html(data);
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
};
